<template>
  <div class="page-container">
    <transition :name="transitionName">
      <router-view></router-view>
    </transition>
    <div class="tab-bar-outer">
      <tab-bar></tab-bar>
    </div>

    <div class="menu-modal" v-show="showMenuModal" @click="hideModal">
      <div class="modal-box">
        <img :src="closeUrl" alt="" class="close">
        <div  class="menu flex-center-between"  v-for="(item, i) in menuList" :key="i" :class="menuIndex == i ? 'active' : ''" @click.stop="chooseMenu(i, item)">
          <div class="flex-center">
            <img :src="item.url" alt="">
            <span>{{item.name}}</span>
          </div>
          <div class="icon flex-center" v-show="menuIndex == i">
            <img :src="checkedUrl" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabBar from '@/components/tabbar'
export default {
  name: 'home',
  components: {
    tabBar
  },
  data() {
    return {
      transitionName: '',
      closeUrl: require('../../assets/imgs/icon-close2.png'),
      checkedUrl: require('../../assets/imgs/icon-checked3.png'),
      menuIndex: -1
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right'
      } else if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-left'
      }

      let name = to.name
      if (name != 'trade') {
        this.menuIndex = -1
      } else {
        let type = this.$route.query.type
        this.menuIndex = type == 2 ? 0 : (type == 3 ? 1 : (type == 1 ? 2 : 0))
      }
    }
  },
  computed: {
    showMenuModal() {
      return this.$store.state.showMenuModal
    },
    menuList() {
      return [
         {
          url: require('../../assets/imgs/trade3.png'),
          name: this.$t('common.trade3'),
          type: 2
        },
        {
          url: require('../../assets/imgs/trade4.png'),
          name: this.$t('common.trade4'),
          type: 3
        },
        {
          url: require('../../assets/imgs/trade2.png'),
          name: this.$t('common.trade2'),
          type: 1
        },
        // {
        //   url: require('../../assets/imgs/trade1.png'),
        //   name: this.$t('common.trade1'),
        // },
      ]
    }
  },
  mounted() {
    let routeName = this.$route.name
    if (routeName == 'trade') {
      let type = this.$route.query.type
      this.menuIndex = type == 2 ? 0 : (type == 3 ? 1 : (type == 1 ? 2 : 0))
    }
  },
  methods: {
    hideModal() {
      this.$store.state.showMenuModal = false
    },
    chooseMenu(i, data) {
      this.menuIndex = i
      if (i == 3) {
        sessionStorage.setItem('routeBak', this.$route.name)
        sessionStorage.setItem('routeQuery', JSON.stringify(this.$route.query))
        this.$router.replace({
          name: 'imitate',
        })
      } else {
        this.$router.replace({
          name: 'trade',
          query: {
            type: data.type
          }
        })
      }
      this.$store.state.showMenuModal = false
    }
  }
}
</script>